<template>
  <ErrorPage code="401" />
</template>

<script>
import ErrorPage from "@/components/Common/ErrorPage.vue";

// Not signed in, or the session ended
export default {
  name: "Unauthorized",
  components: { ErrorPage },
};
</script>
